import { createForm } from '../../../factories'

export default createForm(['memberIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/groups/forms/relateMembers.js